import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>We’re sorry. The prior authorization process cannot be completed at this time. Please try again later. </p>
			</div>
		);	
	}
}